"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneAuthView = PhoneAuthView;
var React = _interopRequireWildcard(require("react"));
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _FormContainer = require("./containers/FormContainer");
var _tracking = require("../../utils/tracking");
var _NoticeContainer = require("../NoticeContainer");
var _HelpContainer = require("../HelpContainer");
var _PromoBannerContainer = require("../PromoBannerContainer");
var _SubtitleContainer = require("../SubtitleContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PhoneAuthView(_ref) {
  let {
    source
  } = _ref;
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackPhoneAuthNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleContainer.SubtitleContainer, null), /*#__PURE__*/React.createElement(_NoticeContainer.NoticeContainer, null), /*#__PURE__*/React.createElement(_FormContainer.FormContainer, null), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    onClick: handleHelpClick
  }), /*#__PURE__*/React.createElement(_PromoBannerContainer.PromoBannerContainer, null));
}